import { createFileRoute } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { SsoTenantLogin } from '../../components';

export const Route = createFileRoute('/sso/$tenant')({
  component: SsoTenantWithRouteParam,
});

function SsoTenantWithRouteParam() {
  const auth: Authn = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const params = Route.useParams();
  const navigate = Route.useNavigate();

  return <SsoTenantLogin<`/sso/$tenant`> {...{ auth, navigate, tenant: params.tenant }} />;
}
